import { render, staticRenderFns } from "./closing_push_details.vue?vue&type=template&id=45d98a26&"
import script from "./closing_push_details.vue?vue&type=script&lang=js&"
export * from "./closing_push_details.vue?vue&type=script&lang=js&"
import style0 from "./closing_push_details.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports